/* eslint-disable react/prop-types */
import { Spinner } from "reactstrap";

export default function Step2SmartMatching() {
  return (
    <div className="border rounded p-5 bg-white text-center">
      <Spinner color="primary" className="mb-4" style={{ width: "3rem", height: "3rem" }} />
      <p className="text-muted mb-0 fs-5 px-md-5">
        Smart matching is running, the system is finding best workers for your shifts
      </p>
    </div>
  );
}
